export const SITE_SELECTOR_STEP_DESCRIPTIONS = {
  OUS: 'Include Individual Site statistics in the report?',
  DDU: 'Include Individual Site statistics in the report?',
  DSU: 'Include Individual Site statistics in the report?',
  DUBG: 'Select up to 10 groups',
  SUBG: 'Select up to 10 groups',
  ISR: 'To view the statistics for one or more of your sites, click the Select Sites button.',
  OSR: 'Include Individual Site statistics in the report?',
  UGR: 'Select your output',
  SRISR: 'To view the statistics for one or more of your sites, click the Select Sites button.'
};
